import React from "react";
import CellPlaceholder from '@app/component/placeholder/CellPlaceholder';


const TablePlaceholder = React.memo(()=> {
    return <div
        className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none bg-white p-4 sm:p-10 rounded-xl">
        <div className="animate-pulse">
            <div className="flex items-center justify-between pt-4">
                <div>
                    <div className="h-2.5 bg-gray-200 rounded-full w-24 mb-2.5"></div>
                    <div className="w-32 h-2 bg-gray-200 rounded-full"></div>
                </div>
                <div className="h-2.5 bg-gray-200 rounded-full w-12"></div>
            </div>
            <div className="mt-8 flow-root">
                <div className="overflow-x-auto">
                    <div className="inline-block min-w-full align-middle">
                        <table className="min-w-full divide-y divide-gray-300 text-gray-500">
                            <tbody className="divide-y divide-gray-200 bg-white align-top">
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
})

export default TablePlaceholder;